import {commonConfig} from "@/config/common";

export default {
  computed: {
    sysFormTitles() {
      return this.$store.state.formTitles
    },
    sysRequiredFields() {
      return this.$store.state.requiredFields;
    },
    // 服务配置
    serviceSetting() {
      return this.$store.state.sysConfig.serviceSetting || {}
    },
    // 客户级别
    customerGradeCols() {
      const {customerGrades} = this.$store.state.sysConfig;
      return (customerGrades || []).map(e => ({...e, text: e.label})).reverse()
    },
    // 系统视频会议选项
    sysTlcMFs() {
      const {tlcMFSettings} = this.$store.state.sysConfig;
      // console.log(tlcMFSettings);
      return (tlcMFSettings || []).map(e => e.manufacturer)
    },
    // 系统配置的直播厂家
    sysLvcManufacturer() {
      const {lvcManufacturer} = this.$store.state.sysConfig;
      return lvcManufacturer || '';
    },
    // 直播可见范围选项
    sysLvcPrivileges() {
      return this.$store.state.sysConfig.lvcPrivileges || [];
    },
    // 扩展字段
    extensionFieldSettings() {
      const {extensionFieldSettings} = this.$store.state.sysConfig;
      return extensionFieldSettings || []
    },
    // 开始、结束提醒时间相关配置
    sysNoticeInfo() {
      const {disableMeetingNotice, preNoticeTime, endNoticeTime} = this.$store.state.sysConfig;
      return {
        enableNotice: !disableMeetingNotice,
        preNoticeTime,
        endNoticeTime
      }
    },
    preNoticeChoiceCols() {
      const {preNoticeChoices} = this.$store.state.sysConfig;
      return (preNoticeChoices || []).map(e => ({...e, text: e.label}))
    },
    endNoticeChoiceCols() {
      return Object.keys(commonConfig.endNoticeChoices).map(k => ({
        label: commonConfig.endNoticeChoices[k],
        text: commonConfig.endNoticeChoices[k],
        value: Number(k)
      }))
    },
    preNoticeChoiceMap() {
      const map = {};
      const {preNoticeChoices} = this.$store.state.sysConfig;
      (preNoticeChoices || []).forEach(ele => map[ele.value] = ele.label);
      return map
    },
    endNoticeChoiceMap() {
      return commonConfig.endNoticeChoices
    },
  },
  // 刷新页面异步返回，需做处理
  watch: {
    sysTlcMFs: function (val) {
      if (this.teleconferenceMF || this.isOrganizeMeetings) return;
      if (val.length && !this.mid) {
        this.teleconferenceMF = val[0];
      }
    },
    sysRequiredFields: function (val) {
      if (!this.mid && val && Object.keys(val).length) {
        if (this.sysRequiredFields.numberOfPeople) {
          this.dataSource.numberOfPeople = undefined;
        }
        if (this.sysRequiredFields.insideParticipant) {
          this.dataSource.insideParticipant = []
        }
        if (this.sysRequiredFields.sponsor) {
          this.dataSource.sponsor = {};
        }
        if (this.sysRequiredFields.initiator) {
          this.dataSource.initiator = {};
        }
      }
    },
    extensionFieldSettings: function (val) {
      this.formatExtFields()
    },
  },
  methods: {
    getNoticeTime(stateName, time, dftTime) {
      return this[stateName] && this[stateName].hasOwnProperty(time) ? time : dftTime
    },
  }
}
